import type { JSX } from 'react'

export const PauseIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use href='#pauseIcon' height='100%' width='100%' />
    <use
      href='#pauseSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
